export default __webpack_public_path__ + "static/media/2473.d06e0273.png";